
import { defineComponent, computed, ref } from "vue";
import useApplications from "@/use/application";
import Page from "../components/shared/layout/Page.vue";
import { useRoute } from "vue-router";
import ApplicationView from "@/views/ApplicationView.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { useStore } from "vuex";

export default defineComponent({
  setup() {
    const route = useRoute();
    const store = useStore();
    const { getUserApplications, getUserApplication } = useApplications();

    const canApplyForNewApps = computed<boolean>(() => {
      return (store.state.applicationsModule.creditUnions || []).length <= 1 ? false : true;
    });

    const pageRef = ref<InstanceType<typeof Page> | null>(null);
    const loading = ref<boolean>(true);

    const sortedApplications = computed(() => {
      if (route.query.lender) {
        return store.state.applications?.filter((a: any) => a.subDomain === route.query.lender);
      } else {
        return store.state.applications;
      }
    });

    return {
      getUserApplications,
      getUserApplication,
      route,
      store,
      sortedApplications,
      pageRef,
      loading,
      canApplyForNewApps,
    };
  },
  components: {
    Page,
    ApplicationView,
  },
  data: () => ({
    userApplications: [],
  }),
  computed: {
    ...mapState(["applications", "configuration", "lenderData", "applicationsModule"]),
    ...mapGetters("oidcStore", ["oidcUser"]),
    ...mapGetters("applicationsModule", ["Branding"]),
  },
  methods: {
    ...mapActions(["setApplications"]),
    viewApplication(referenceId: number) {
      const query = this.$route.query as any;
      // redirect to application page
      this.$router.push({ path: `/applications/${referenceId}`, query });
    },
    applyForNewLoan() {
      const lenderid = this.sortedApplications[0]?.lenderId || this.applications[0].lenderId;
      const productTypeId =
        this.sortedApplications[0]?.productTypeId || this.applications[0].productTypeId;
      const programTypeId =
        this.sortedApplications[0]?.programTypeId || this.applications[0].programTypeId;

      window.location.replace(
        `${this.store.state.borrowerAppUrl}/application?lid=${lenderid}&productTypeId=${productTypeId}&leadSourceId=1&programTypeId=${programTypeId}`,
      );
    },
    viewAllApps() {
      this.$router.push({
        path: `/applications/lenders`,
      });
    },
    async refreshApplications() {
      this.userApplications = await this.getUserApplications(this.oidcUser.sub);
      this.setApplications(this.userApplications);
    },
  },
  watch: {
    $route() {
      console.log("route changed...");
    },
    loading: {
      handler(value) {
        this.pageRef?.setLoading(value);
      },
      immediate: true,
    },
  },
  async mounted() {
    this.pageRef?.setLoading(true);
    this.loading = true;

    await this.refreshApplications();

    if (this.route.query.lid) {
      this.store.dispatch("applicationsModule/setLenderId", Number(this.route.query.lid));
      await this.store.dispatch("applicationsModule/setCreditUnionColorScheme", this.Branding);
    }

    if ((this.applications || []).length === 1) {
      this.$router.push({
        path: `/applications/${this.applications[0].referenceId}`,
      });
    }

    this.loading = false;
  },
});
